import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { loginModel } from 'src/app/Interface/login';
import {
  ApiRequestsService,
  RESPONSE,
} from 'src/app/services/api-requests.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { DataManipulateService } from 'src/app/services/data-manipulate.service';


interface LoginResponse {
  token: string;
  user_id: number;
  role:string;
  name:string;
  phone:number;
  email:string;
  rewardPoints:number;
  accepted_entry:number;
  submitted_entry:number;
  rejected_entry:number;
}

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent {
  public model: loginModel = { email: '', passwd: '' };
  showPassword: boolean = false;
  erroremail: string = '';
  errorpasswd: string = '';
  errorMsg: string = '';
  inputType: string = 'password';
  role: string = '';
  userName: string = '';
  isLoadingData: boolean = false;

  constructor(private apiRequests: ApiRequestsService, private route: Router, private common: CommonFunctionService, private authService: AuthService, private toster: ToastrService, private data: DataManipulateService
  ) { }

  resetError = () => {
    this.errorMsg = '';
    this.erroremail = '';
    this.errorpasswd = '';
  };

  validateFields = (): boolean => {
    const UserValidateion = this.validateUserId();
    const PasswordValidation = this.validatePassword();
    return UserValidateion && PasswordValidation;
  };

  validateUserId = (): boolean => {
    if (!this.model.email.trim()) {
      this.errorMsg = 'Please specify User Id';
      return false;
    }

    return true;
  };

  validatePassword = (): boolean => {
    if (!this.model.passwd.trim()) {
      this.errorMsg = 'Please specify Password';
      return false;
    }
    return true;
  };

  login = async () => {
    this.resetError();
    if (!this.validateFields()) {
      return;
    }
    this.isLoadingData = true;
    const result: RESPONSE = await this.apiRequests.postApiCallReturningPromise('user/userLogin', this.model);
    if (result['errorCode'] == this.apiRequests.NO_ERROR) {
      this.apiRequests.updateOrSetTokenValue(result['Data']['ntk']);
      this.apiRequests.token = result['Data']['ntk'];
      // this.common.user_id=result.user_id;
      // this.common.token=result.token;
      this.common.userName = result.Data.name;
      this.common.role = result.Data.role;
      this.isLoadingData = false;
      this.toster.success(result['errorDescription']);
      this.route.navigate(['/dashboard']);
    } else {
      this.isLoadingData = false;
      this.toster.error(result['errorDescription']);
    }
  };
  passwordVisiblity() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }
}
